import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React from 'react'

interface DetailProps {
  listEl: any
  userList: any
  postedStatus: string
}

const formatPeriod = (year: number, period: number) => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  return `${months[period - 1]}/${year}`
}

export const HistoryDepreciationDetailContent = (props: DetailProps) => {
  const { listEl, userList, postedStatus } = props

  return (
    <>
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Year
        </div>
        <div className="mdDesc">{listEl?.year}</div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Period
        </div>
        <div className="mdDesc">
          {formatPeriod(listEl?.year, listEl?.period)}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Depreciation Amount
        </div>
        <div className="mdDesc">{amtStr(listEl?.depreciation_amount)}</div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Accumulated Depreciation
        </div>
        <div className="mdDesc">{amtStr(listEl?.accumulated_depreciation)}</div>
      </div>

      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          Net Book Value (After Depreciation)
        </div>
        <div className="mdDesc">
          {amtStr(listEl?.net_book_value_after_depreciation)}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Depreciation Method
        </div>
        <div className="mdDesc">{listEl?.DepreciationMethod?.name || 0}</div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Residual Value Used
        </div>
        <div className="mdDesc">{amtStr(listEl?.residual_value_used)}</div>
      </div>

      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          Formula Used
        </div>
        <div className="mdDesc text-noflow">
          {listEl?.DepreciationFormula?.expression[0]?.Formula || '-'}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Generated Date'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {formatDate(listEl?.createdTs)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Generated By'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {userList?.filter(user => user.ID == listEl?.createdBy)[0]?.name}
        </div>
      </div>
    </>
  )
}
